import { formatHoursValue, createKpiTileItem } from '../../../../utils/helper';
import { KpiHandler, IPCSummaryData } from './types';
import { KpiData } from 'components/redesign/KpiTile/types';

const agentRuntimeHours: KpiHandler = {
  type: 'KpiTile',
  handler: (data: IPCSummaryData): KpiData => {
    const { agentRuntimeHours } = data;

    const formattedValue = formatHoursValue(agentRuntimeHours);

    return createKpiTileItem('Agent Runtime Hours', formattedValue, []);
  },
};

export default agentRuntimeHours;
